import { isArrayNotEmpty } from '@/helpers/array';
import {
  GCLID,
  MSCLKID,
  REFERRAL_CODE,
  UTM_QUERY_PARAMS,
  SESSION_START_PAGE,
  SESSION_REFERRER_PAGE,
  SESSION_PREVIOUS_PAGES,
} from '../constants/session-storage';

export type UtmTrackingQueryParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
};

export type TrackingIdentifiers = {
  gclid?: string;
  msclkid?: string;
  referral_code?: string;
} & UtmTrackingQueryParams;

const isSessionStorageAvailable = () => Boolean(global?.window?.sessionStorage);

const setNewItem = (key: string, value?: string) => {
  if (!isSessionStorageAvailable()) return;

  if (
    sessionStorage.getItem(key) === null &&
    value !== null &&
    value !== undefined
  ) {
    sessionStorage.setItem(key, value);
  }
};

const deduplicateQueryParamIfNecessary = (param: unknown): string => {
  if (isArrayNotEmpty(param)) {
    return (param as string[])[0];
  }

  return param as string;
};

export const setSessionLandingPage = (page: string | null) =>
  setNewItem(SESSION_START_PAGE, page);

export const addSessionPreviousPage = (page: string | null) => {
  if (page && isSessionStorageAvailable()) {
    const previousPages = JSON.parse(
      sessionStorage.getItem(SESSION_PREVIOUS_PAGES) ?? '[]'
    );

    sessionStorage.setItem(
      SESSION_PREVIOUS_PAGES,
      JSON.stringify([...previousPages, page])
    );
  }

  setNewItem(SESSION_REFERRER_PAGE, page);
};

export const setTrackingIdentifiers = ({
  gclid,
  msclkid,
  referral_code,
  utm_source,
  utm_campaign,
  utm_content,
  utm_medium,
  utm_term,
}: TrackingIdentifiers) => {
  if (!isSessionStorageAvailable()) return;

  setNewItem(GCLID, deduplicateQueryParamIfNecessary(gclid));
  setNewItem(MSCLKID, deduplicateQueryParamIfNecessary(msclkid));
  setNewItem(REFERRAL_CODE, deduplicateQueryParamIfNecessary(referral_code));

  const hasAnyUtmParameters = [
    utm_campaign,
    utm_content,
    utm_medium,
    utm_source,
    utm_term,
  ].some(item => Boolean(item));

  if (!sessionStorage.getItem(UTM_QUERY_PARAMS) && hasAnyUtmParameters) {
    sessionStorage.setItem(
      UTM_QUERY_PARAMS,
      JSON.stringify({
        utm_campaign: deduplicateQueryParamIfNecessary(utm_campaign),
        utm_content: deduplicateQueryParamIfNecessary(utm_content),
        utm_medium: deduplicateQueryParamIfNecessary(utm_medium),
        utm_source: deduplicateQueryParamIfNecessary(utm_source),
        utm_term: deduplicateQueryParamIfNecessary(utm_term),
      } as UtmTrackingQueryParams)
    );
  }
};
